module.exports = __webpack_public_path__ + "img/zhaocaimao.0d87b24f.gif";